import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-usa-flag',
  standalone: true,
  templateUrl: '../../assets/usa-flag.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamUsaFlagIcon {}
